module.exports = __webpack_public_path__ + "img/mounting_wedge_wider_range_of_view.66baa5dd.png";